import { cn } from './utils';

/**
 * Centralizes how a broker avatar/image renders. 'circle' (default) is the
 * classic round portrait with `object-cover` — works for human photos.
 * 'square' is for logos/brand marks: soft-rounded rectangle with
 * `object-contain` on a white plate so the full shape (including pointy
 * edges of a crest or logo) is preserved.
 *
 * Pass `sizeCls` separately so the caller controls width/height. This avoids
 * coupling the avatar shape to a fixed size table — different layouts need
 * h-9, h-16, h-48 etc.
 */
export type AvatarShape = 'circle' | 'square' | undefined;

export function brokerAvatarClass(shape: AvatarShape, sizeCls: string): string {
  if (shape === 'square') {
    // Tight padding + white plate keeps the logo from touching the rounded
    // edge while letting `object-contain` show the full brand mark.
    return cn('rounded-2xl bg-white object-contain p-1.5', sizeCls);
  }
  return cn('rounded-full object-cover', sizeCls);
}
